module.exports = __webpack_public_path__ + "static/media/marker.201775cf.svg";